module.exports = __webpack_public_path__ + "img/1 (55).c03d09c7.png";